<template>
    <div>
        <h1 class="page_title">短信模版</h1>
        <div class="filter-container">
            <!-- <el-input size="small" class="filter-item" style="width: 200px;" placeholder="姓名/拼音手机号" v-model="searchKey"></el-input> -->
            <!-- <el-button size="small" class="filter-item">搜索</el-button> -->
            <el-button size="small" class="filter-item" @click="list" icon="el-icon-refresh"></el-button>
            <el-button size="small" class="filter-item" @click="showAddDialog">添加模版</el-button>
        </div>
        <el-table :data="tableRecords" stripe>
            <el-table-column align="left" label="模版名称" width="100">
                <template slot-scope="scope">
                    <span>{{scope.row.subject}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="模版内容" min-width="150">
                <template slot-scope="scope">
                    <span>{{scope.row.content}}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                    <el-button type="warning" size="mini" @click="doDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="修改短信模版" :visible.sync="editDialog" width="500px" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="formRules" label-position="right" label-width="100px">
                <el-form-item class="form_item_val" label="模版名称" prop="subject">
                    <el-input size="small" style="width: 200px;" placeholder="请输入模版名称" v-model="editForm.subject"></el-input>
                </el-form-item>
                <el-form-item class="form_item_val" label="模版内容" prop="content">
                    <el-input type="textarea" v-model="editForm.content" :rows="5" placeholder="请输入模版内容"></el-input>
                </el-form-item>
            </el-form>
            <div style="padding-left:20px;font-size:12px;">
注：模版中可以使用$userName$表示客户姓名，$ownerName$表示该客户的客户经理姓名，$ownerMobile$表示该客户经理的手机号。
            </div>
            <div style="padding-left:20px;font-size:12px;">
例：【$userName$】您好！感谢您在深圳比亚迪店购车，爱车到店之日我会第一时间告知您，期间有何疑问随时来电！期待您的爱车！【$ownerName$ $ownerMobile$】
            </div>
            <div style="padding-left:20px;font-size:12px;">
短信实际显示内容为： 【王先生】您好！感谢您在深圳比亚迪店购车，爱车到店之日我会第一时间告知您，期间有何疑问随时来电！期待您的爱车！【黄小小 18571554092】
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="doSave"  type="text">保存</el-button>
                <el-button @click="editDialog = false" type="text">取消</el-button>
            </span>
        </el-dialog>

       
        <el-dialog title="添加短信模版" :visible.sync="newDialog" width="500px" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="newForm" :model="newForm" :rules="formRules" label-position="right" label-width="100px">
                <el-form-item class="form_item_val" label="模版名称" prop="subject">
                    <el-input size="small" style="width: 200px;" placeholder="请输入模版名称" v-model="newForm.subject"></el-input>
                </el-form-item>
                <el-form-item class="form_item_val" label="模版内容" prop="content">
                    <el-input type="textarea" v-model="newForm.content" :rows="5" placeholder="请输入模版内容"></el-input>
                </el-form-item>
            </el-form>
            <div style="padding-left:20px;font-size:12px;">
注：模版中可以使用$userName$表示客户姓名，$ownerName$表示该客户的客户经理姓名，$ownerMobile$表示该客户经理的手机号。
            </div>
            <div style="padding-left:20px;font-size:12px;">
例：【$userName$】您好！感谢您在深圳比亚迪店购车，爱车到店之日我会第一时间告知您，期间有何疑问随时来电！期待您的爱车！【$ownerName$ $ownerMobile$】
            </div>
            <div style="padding-left:20px;font-size:12px;">
短信实际显示内容为： 【王先生】您好！感谢您在深圳比亚迪店购车，爱车到店之日我会第一时间告知您，期间有何疑问随时来电！期待您的爱车！【黄小小 18571554092】
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="doAdd"  type="text">保存</el-button>
                <el-button @click="newDialog = false" type="text">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { remarkValidator } from '@/assets/js/util'

export default {
    data() {
        return {
            dealer: this.$common.getDealer(),
            user: this.$common.getUser(),
            listQuery: {
                
            },
            tableRecords: [],

            editDialog: false,
            editForm: {},
            formRules: {
                subject: [{
                    required: true,
                    message: "请输入模版名称",
                    trigger: "blur"
                }],
                content: [{
                    required: true,
                    validator: (...args) => {
                      remarkValidator("模板内容", ...args)
                    },
                    trigger: "blur"
                }],
            },
            newForm: {
                subject: "",
                content: "",
            },
            newDialog: false,
        };
    },
    filters: {
        
    },
    mounted() {
        this.list();
    },
    methods: {
        list() {
            var parent = this
            this.$httpAuth
                .post("/v1/dealerSmsTemplateRpc/list", {
                    dealerId: this.dealer.dealerId,
                })
                .then(function (response) {
                    parent.tableRecords = response.data.data
                }).catch(() => {});
        },
        showEditDialog(row) {
            this.editForm = JSON.parse(JSON.stringify(row));
            if (this.$refs["editForm"]) {
                this.$refs["editForm"].resetFields();
            }
            this.editDialog = true;
        },
        doSave() {
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    var parent = this
                    this.$httpAuth
                        .post("/v1/dealerSmsTemplateRpc/update", {
                            "dealerId": this.dealer.dealerId,
                            "id": this.editForm.id,
                            "subject": this.editForm.subject,
                            "content": this.editForm.content,
                        })
                        .then(function () {
                            parent.editDialog = false;
                            parent.list();
                            parent.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }).catch(() => {});
                }
            });
        },
        showAddDialog() {
            this.newForm = {
                subject: "",
                content: "",
            };
            if (this.$refs["newForm"]) {
                this.$refs["newForm"].resetFields();
            }
            this.newDialog = true;
        },
        doAdd() {
            this.$refs["newForm"].validate(valid => {
                if (valid) {
                    var parent = this
                    this.$httpAuth
                        .post("/v1/dealerSmsTemplateRpc/add", {
                            "dealerId": this.dealer.dealerId,
                            "subject": this.newForm.subject,
                            "content": this.newForm.content,
                        })
                        .then(function () {
                            parent.newDialog = false;
                            parent.list();
                            parent.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                        }).catch(() => {});
                }
            });
        },
        doDelete(row) {
            this.$confirm('是否删除该模版?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var parent = this;
                this.$httpAuth
                    .post("/v1/dealerSmsTemplateRpc/delete", {
                        "dealerId": this.dealer.dealerId,
                        "id": row.id,
                    })
                    .then(function () {
                        parent.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        parent.list();
                    })

            })
        }
    }
}
</script>

<style>

</style>
